import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {Tour, Button, Input} from 'kpc';

var _$tmp0 = {
    'style': 'margin-top: 20px;'
};
var _$tmp1 = {
    'style': 'margin-left: 10px;'
};
var _$tmp2 = {
    'style': 'margin-top: 10px; color: #f56c6c'
};
var _$tmp3 = {
    'style': 'margin-top: 20px;'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'id': 'step1',
                'children': '步骤1'
            }),
            _$cc(Button, {
                'id': 'step2',
                'style': 'margin-left: 20px;',
                'children': '步骤2'
            }),
            _$ce(2, 'div', (
                _$cc(Input, {
                    'className': 'step3-input',
                    'placeholder': '通过验证才能进入下一步',
                    'ev-$model:value': function($v) {
                        $this.set('inputValue', $v);
                    },
                    'value': $this.get('inputValue')
                })
            ), 2 /* HasVNodeChildren */, null, _$tmp0),
            _$cc(Button, {
                'id': 'step4',
                'style': 'margin-top: 20px;',
                'children': '步骤4'
            })
        ], 4 /* HasNonKeyedChildren */, 'example-container'),
        _$cc(Tour, {
            'visible': this.get('showTour'),
            'data': this.get('tourData'),
            'beforeChange': this.handleBeforeChange,
            'ev-finish': this.finishTour,
            'ev-$model:value': function($v) {
                $this.set('currentStep', $v);
            },
            'value': $this.get('currentStep')
        }),
        _$ce(2, 'div', [
            _$cc(Button, {
                'ev-click': this.startTour,
                'children': '\n            启动引导\n        '
            }),
            _$ce(2, 'span', [
                _$ct('\n            当前步骤: '),
                this.get('currentStep') >= 0 ? this.get('currentStep') + 1 : '未启动'
            ], 0 /* UnknownChildren */, null, _$tmp1),
            (this.get('errorMsg')) ?
                _$ce(2, 'div', this.get('errorMsg'), 0 /* UnknownChildren */, null, _$tmp2) :
                undefined
        ], 0 /* UnknownChildren */, null, _$tmp3)
    ], 4 /* HasNonKeyedChildren */);
};